/* unplugin-vue-components disabled */import script from "./MpPhoneFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./MpPhoneFrame.vue?vue&type=script&setup=true&lang=js"

import "./MpPhoneFrame.vue?vue&type=style&index=0&id=957815dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-957815dc"]])

export default __exports__